





















































import {Vue, Component, Prop} from 'vue-property-decorator';
import OrderStatusAlert from '@/components/Views/Dashboard/Orders/OrderStatusAlert.vue';
import {multiNil, nil, ORDER_STATUS} from '@/common';
import {Mixins} from 'vue-property-decorator';
import CurrencyMixin from '@/mixins/CurrencyMixin.vue';
@Component({
    components: {
        OrderStatusAlert,
    },
})
export default class OrderMetadata extends Mixins(CurrencyMixin) {

    @Prop({default: ''})
    public customerEmail!: string;
    @Prop({default: ''})
    public customerPhone!: string;
    @Prop({default: ''})
    public dateCreated!: string;
    @Prop({default: ''})
    public dateUpdated!: string;
    @Prop({default: ''})
    public customerConfirmed!: string;
    @Prop({default: () => ({})})
    public stripePayment!: any;
    @Prop({default: 0})
    public giftCardPayment!: number;
    @Prop({default: ORDER_STATUS.ACCEPTED})
    public status!: string;

    @Prop({default: 0})
    public servicesTotal!: number;
    @Prop({default: 0})
    public proCutTotal!: number;
    @Prop({default: 0})
    public proTipTotal!: number;
    @Prop({default: 0})
    public discountTotal!: number;
    @Prop({default: 0})
    public giftCardTotal!: number;
    @Prop({default: 0})
    public refundedGiftCardPayment!: number;

    public get stripeStatus() {
        if (multiNil(this, 'stripePayment.status')) { return ''; }
        return this.stripePayment.status;
    }
    public get stripeLink() {
        if (multiNil(this, 'stripePayment.id')) { return ''; }
        return `https://dashboard.stripe.com/test/payments/${this.stripePayment.id}`;
    }
    public get total() {
        if (multiNil(this, 'stripePayment.amount')) { return ''; }
        return this.priceDisplay(this.stripePayment.amount / 100);
    }
    public get canCancel() {
        return this.status !== ORDER_STATUS.CANCELLED;
    }
    public get canAccept() {
        return this.status === ORDER_STATUS.REQUIRES_REVIEW;
    }
    public get proPaymentTotal() {
        if (nil(this.proCutTotal, true) || nil(this.proTipTotal, true)) {
            return '';
        }
        return this.priceDisplay(this.proCutTotal + this.proTipTotal);
    }
    public get hasFullPaymentInfo() {
        return !nil(this.proPaymentTotal, true);
    }
    public get customerCardholder(){
        const {charges} = this.stripePayment;
        if(nil(charges) || nil(charges.data, true) || nil(charges.data[0].billing_details)){
            return 'None Provided';
        }
        return charges.data[0].billing_details.name;
    }

}
